import { Controller } from "@hotwired/stimulus"
import { showStatusBadge } from "../utils/statusBadge"

export default class extends Controller {
  static targets = ["toggle", "message"]
  static values = { enabled: Boolean }

  connect() {
    this.toggleTarget.checked = this.enabledValue
    this.showMessageForState(this.enabledValue)
  }

  async toggle() {
    const checked = this.toggleTarget.checked

    try {
      const response = await fetch("/settings", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ user: { email_notifications_enabled: checked } })
      })

      if (!response.ok) throw response

      const data = await response.json()
      const enabled = data.email_notifications_enabled
      this.toggleTarget.checked = enabled
      this.showMessageForState(enabled)
    } catch {
      this.toggleTarget.checked = !checked
      this.showMessage("Failed to save preference. Please try again.", "error")
    }
  }

  showMessageForState(enabled) {
    this.showMessage(
      enabled ? "Email notifications are enabled" : "Email notifications are disabled",
      enabled ? "enabled" : "disabled"
    )
  }

  showMessage(text, tone = "disabled") {
    if (!this.hasMessageTarget) return
    showStatusBadge(this.messageTarget, text, tone)
  }
}
